import { combineReducers } from 'redux';
import Auth from './Auth';
import UserProfile from './UserProfile';
import Theme from './Theme';
import HeaderSearch from "./HeaderSearch";

const reducers = combineReducers({
  theme: Theme,
  auth: Auth,
  userProfile: UserProfile,
  headerSearch: HeaderSearch,
});

export default reducers;